import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledNotificationPreferences = styled.div`
  display: grid;
  gap: 16px;

  .np-loading {
    display: grid;
    place-items: center;
    min-height: 160px;
  }

  .np-header h2 {
    margin: 0;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .np-status {
    font-size: 12px;
    opacity: 0.7;
    color: ${({ theme }) => theme.underTextColor};
  }

  .np-groups {
    display: grid;
    gap: 0;
  }

  .np-group {
    padding: 12px 0;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .np-section-title {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: ${({ theme }) => theme.contractTextTitleColor};
  }

  .np-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;

    .ant-checkbox-wrapper {
      align-items: center;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .np-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;
